import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useAgreementFieldRenderer } from "./useAgreementFieldRenderer";
import type { AgreementField } from "@/types/agreement";

const yellowHighlightBg = "bg-yellow-200 hover:bg-yellow-300";

interface AgreementDataRowLabelValueProps {
  translationPrefix: string;
  fieldKey: string;
  field: AgreementField;
  value: unknown;
  data: Record<string, unknown>;
  hasHighlight: boolean;
}

export const AgreementDataRowLabelValue = ({
  translationPrefix,
  fieldKey,
  field,
  value,
  data,
  hasHighlight,
}: AgreementDataRowLabelValueProps) => {
  const { t } = useTranslation();
  const renderCell = useAgreementFieldRenderer(field);

  return (
    <>
      <td className="w-1/4 pl-2 pr-2 align-top relative">
        <div className="absolute inset-y-2 right-0 w-px bg-gray-200" />
        <div className="py-1 text-xs font-medium text-gray-600 leading-tight">
          {t(`${translationPrefix}.${fieldKey}`)}:
        </div>
      </td>
      <td
        className={cn("w-1/4 px-2 align-top", {
          [yellowHighlightBg]: hasHighlight,
        })}
      >
        {renderCell(value, data)}
      </td>
    </>
  );
};
